/**
 * Valores iniciais do formulário de Employee.
 */
export const employeeDefaults = {
    firstName: "",
    lastName: "",
    email: "",
    role: "",
    status: "active",
    xpTotal: 0,
    phone: "",
    cpf: "",
    photoUrl: null,
    password: "",
    gender: "",
    birthDate: "",
    professionalRegistration: "",
    address: {
        zipCode: "",
        state: "",
        city: "",
        neighborhood: "",
        street: "",
        number: ""
    }
};
